import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['pack', 'startDate', 'nextDate'];

    static values = {
        lastIntervention: String,
    };

    connect() {
        this.bindPackListener();
        this.updateNextDate();
    }

    bindPackListener() {
        if (!this.hasPackTarget) {
            return;
        }

        const select = this.packTarget;
        select.addEventListener('change', () => this.updateNextDate());

        const bindTomSelect = () => {
            if (select.tomselect) {
                select.tomselect.on('change', () => this.updateNextDate());

                return true;
            }

            return false;
        };

        if (!bindTomSelect()) {
            window.addEventListener('load', () => bindTomSelect(), { once: true });
            setTimeout(() => bindTomSelect(), 150);
        }
    }

    updateNextDate() {
        if (!this.hasNextDateTarget) {
            return;
        }

        const months = this.getIntervalMonths();
        const baseDate = this.getBaseDate();

        if (months === null || baseDate === null) {
            return;
        }

        const next = this.addMonths(baseDate, months);
        this.nextDateTarget.value = this.formatDateInput(next);
    }

    getIntervalMonths() {
        if (!this.hasPackTarget) {
            return null;
        }

        const select = this.packTarget;
        const value = select.tomselect?.getValue() ?? select.value;
        if (value === '' || value === null) {
            return null;
        }

        const option =
            select.querySelector(`option[value="${CSS.escape(String(value))}"]`) ??
            select.selectedOptions[0];
        if (!option) {
            return null;
        }

        const months = parseInt(option.dataset.intervalMonths, 10);

        return Number.isFinite(months) && months > 0 ? months : null;
    }

    getBaseDate() {
        if (this.lastInterventionValue) {
            const fromIntervention = new Date(this.lastInterventionValue);
            if (!Number.isNaN(fromIntervention.getTime())) {
                return fromIntervention;
            }
        }

        if (!this.hasStartDateTarget || !this.startDateTarget.value) {
            return null;
        }

        const parsed = new Date(this.startDateTarget.value);
        if (Number.isNaN(parsed.getTime())) {
            return null;
        }

        return parsed;
    }

    addMonths(date, months) {
        const result = new Date(date.getTime());
        result.setMonth(result.getMonth() + months);

        return result;
    }

    formatDateInput(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }
}
